import { Link } from "react-router-dom";
import styled from "styled-components";

import { FiArrowUpRight } from 'react-icons/fi';

const Button = ({ text, to, variant, noIcon }) => {
    return (
        <StyledButton to={to} variant={variant}>
            {!noIcon && <FiArrowUpRight />}
            {text}
        </StyledButton>
    )
}

const StyledButton = styled(Link)`
    background-color: ${({ theme, variant }) => variant === "primary" ? theme.colors.primary : theme.colors.secondary};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
    padding: 1.5rem 2.5rem;
    border: none;
    outline: none;
    border-radius: 4px;
    font-size: 1rem;
    font-weight: ${({ theme }) => theme.fontWeights.semiBold};
    color: ${({ theme }) => theme.colors.white};
    text-decoration: none;
    cursor: pointer;

    @media (max-width: 768px) {
        font-size: .875rem;
        padding: 1.25rem 2rem;
    }
`;

export default Button;